// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__vmoKq {
  display: none;
}
@media (max-width: 992px) {
  .styles_wrapper__vmoKq {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-height: 57px;
    padding: 0 15px;
    background: #100f0f;
  }
}

.styles_headerWrapper__bhT4A {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.styles_logoWrapper__WOahr {
  display: flex;
  align-items: center;
}

.styles_logoIcon__u59IP svg {
  width: 47px;
  height: 47px;
}

.styles_logoText__Nfrap {
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: #ffffff;
}

.styles_walletWrapper__udQsW {
  padding-bottom: 15px;
}

.styles_iconActive__YhkMA path {
  stroke: #ff136d;
}`, "",{"version":3,"sources":["webpack://./src/components/pageWrapper/pageHeaderMobile/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;AAFF;ACuBE;EDtBF;IAII,aAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;IACA,eAAA;IACA,mBEQO;EFTT;AACF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,cEvCM;AFsCR;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,eErCK;AFoCP","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: none;\n\n  @include lg {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    min-height: 57px;\n    padding: 0 15px;\n    background: $black-bg;\n  }\n}\n\n.headerWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logoWrapper {\n  display: flex;\n  align-items: center;\n}\n\n.logoIcon svg {\n  width: 47px;\n  height: 47px;\n}\n\n.logoText {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white;\n}\n\n.walletWrapper {\n  padding-bottom: 15px;\n}\n\n.iconActive path {\n  stroke: $pink;\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__vmoKq`,
	"headerWrapper": `styles_headerWrapper__bhT4A`,
	"logoWrapper": `styles_logoWrapper__WOahr`,
	"logoIcon": `styles_logoIcon__u59IP`,
	"logoText": `styles_logoText__Nfrap`,
	"walletWrapper": `styles_walletWrapper__udQsW`,
	"iconActive": `styles_iconActive__YhkMA`
};
export default ___CSS_LOADER_EXPORT___;
